import firebase from 'firebase/app';

export default {
  namespaced: true,
  state: {
    loggedIn: null,
    items: {}
  },
  getters: {
    loggedInUser(state) {
      return state.loggedIn ? {
        id: state.loggedIn,
        ...state.items[state.loggedIn]
      } : null;
    },
    items: state => state.items,
  },
  mutations: {
    setLoggedIn(state, id) {
      state.loggedIn = id;
    },
  },
  actions: {
    createUser({ state, commit }, data) { // eslint-disable-line
      const { uid, email, displayName } = data;
      const id = uid;
      const registeredAt = Math.floor(Date.now() / 1000);
      const user = {
        email,
        name: displayName,
        registeredAt
      };

      return new Promise((resolve) => {
        firebase.firestore().collection('users').doc(id)
          .set(user)
          .then(() => {
            commit('setItem', { resource: 'users', id, item: user }, { root: true });
            resolve(state.items[id]);
          });
      });
    },
    fetchUser: ({ dispatch }, { id }) => dispatch('fetchItem', { resource: 'users', id }, { root: true }),
    fetchUsers: ({ dispatch }, { ids }) => dispatch('fetchItems', { resource: 'users', ids }, { root: true }),
    findUser: ({ dispatch }, query) => dispatch('findItem', { resource: 'users', query }, { root: true }),
    findUsers: ({ dispatch }, query) => dispatch('findItems', { resource: 'users', query }, { root: true }),
    updateUser: ({ dispatch }, { id, data }) => dispatch('updateItem', { resource: 'users', id, data }, { root: true }),
  }
};
